import React from 'react'

import MenuItem from './MenuItem'

const MenuMobile = ({ collapsed, menuItems }) => (
  <div
    className='menu hidden-desktop flex-column full-width'
    style={{ display: collapsed ? 'none' : 'initial' }}
  >
    <div className='flex-column' style={{ fontSize: '16px' }}>
      {menuItems.map(item => (
        <MenuItem key={item.route} {...item} showLabel />
      ))}
    </div>
  </div>
)

export default MenuMobile
